import {SaleTypeDto} from "../../dtos";
import {Action} from "../actions/saleTypeActions";
import {ActionType} from "../actionTypes";

export interface SaleTypes {
    saleTypes: any;
    saleTypesForSpecificFlyer: any;
    sellingUnits: any;
}

export class SaleTypesInitialState implements SaleTypes {
    saleTypes = [];
    saleTypesForSpecificFlyer = [];
    sellingUnits = [];
}

const compare = (a: SaleTypeDto, b: SaleTypeDto) => {
    if (a.satCode! < b.satCode!) {
        return -1;
    }
    if (a.satCode! > b.satCode!) {
        return 1;
    }
    return 0;
}

const initialState = new SaleTypesInitialState();

const reducer = (state: SaleTypes = initialState, action: Action) => {

    switch(action.type)
    {
        //
        case ActionType.SET_SALE_TYPES_FOR_ALL_FLYERS:
            return { ...state, saleTypes: action.payload.sort(compare) };
        case ActionType.GET_SALE_TYPES_FOR_ALL_FLYERS:
            return { ...state.saleTypes };
        case ActionType.SET_SALE_TYPES_FOR_SPECIFIC_FLYER:
            return { ...state, saleTypesForSpecificFlyer: action.payload.sort(compare) };
        case ActionType.GET_SALE_TYPES_FOR_SPECIFIC_FLYER:
            return { ...state.saleTypesForSpecificFlyer };
        default:
            return state;
    }
}

export default reducer;
